import type { TMessages } from '@/types/TMessages'

export const messages = {
  trigger: {
    title: 'Формула определения цены',
  },
  formula: {
    sum: 'Цена на базисе поставки без НДС',
    auctions: {
      title: 'Аукционы НТБ',
      text: 'средняя цена за предшествующие переписи 3 рабочих дня',
    },
    storageCosts: 'Расходы на хранение и отгрузку товара на элеваторе',
    railwayTariff: 'Тариф ЖД от базиса поставки до терминала',
    discount: {
      title: 'Дисконт',
      text: 'плата за пользование авансом',
    },
    operator: {
      equal: '=',
      minus: '-',
      multiply: '×',
    },
  },
  warning: {
    sign: '*',
    text: 'Прибавляются нормативные потери товара и плата за финансирование товара (если базис поставки отличается от СРТ)',
  },
} satisfies TMessages
